import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { useDocumentoSetorialDetailsDispatch } from './documento-setorial-details-context';
import { ACTION_TYPES } from './documento-setorial-details-reducer';

export const useDocumentoSetorialDetailsController = () => {
  const dispatch = useDocumentoSetorialDetailsDispatch();

  const loadDocumentoSetorialDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getDocumentoSetorial(id);

      dispatch({ type: ACTION_TYPES.setDocumentoSetorialDetails, payload: response });
    } catch (error) {
      console.error('Error loading documento setorial details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes do documento setorial' });
      dispatch({ type: ACTION_TYPES.setDocumentoSetorialDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearDocumentoSetorialDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setDocumentoSetorialDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportDocumentoSetorialDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportDocumentoSetorialDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadDocumentoSetorialDetails,
    clearDocumentoSetorialDetails,
    exportDocumentoSetorialDetail,
  };
};
